import { useMemo } from 'react';

import { useDeprecate } from '@adsk/alloy-react-helpers';
import { RenderIconType } from '@adsk/alloy-react-icon';

import { RenderElementType } from '../types';

export type RenderProps = {
  /** @deprecated use renderLeftElement*/
  renderLeftIcon?: RenderIconType;
  /** @deprecated use renderRightElement*/
  renderIcon?: RenderIconType;
  renderLeftElement?: RenderElementType;
  renderRightElement?: RenderElementType;
};

/**
 * renderLeftElement and renderRightElement will be the only options after a breaking change.
 * At that point we can remove this hook entirely
 */
export default ({
  renderIcon,
  renderRightElement,
  renderLeftIcon,
  renderLeftElement,
}: RenderProps) => {
  useDeprecate(!!renderIcon, 'TextInput', 'renderIcon', 'renderRightElement');
  useDeprecate(
    !!renderLeftIcon,
    'TextInput',
    'renderLeftIcon',
    'renderLeftElement',
  );

  const renderLeft: RenderElementType | RenderIconType | undefined = useMemo(
    () => renderLeftElement || renderLeftIcon,
    [renderLeftElement, renderLeftIcon],
  );

  const renderRight: RenderElementType | RenderIconType | undefined = useMemo(
    () => renderRightElement || renderIcon,
    [renderIcon, renderRightElement],
  );

  return {
    renderLeft,
    renderRight,
  };
};
